import { h } from 'preact';

const CustomPageViewAllArrowRight = ({ color = '#000' }) => (
  <svg
    width="18px"
    height="14px"
    viewBox="0 0 18 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(9.000000, 7.000000) rotate(180.000000) translate(-9.000000, -7.000000) "
        fill={color}
        fillRule="nonzero"
      >
        <path d="M7,0.3417969 C6.744125,0.3417969 6.4879688,0.4412187 6.2929688,0.6367188 L0.6367188,6.292969 C0.2457187,6.683969 0.2457187,7.317031 0.6367188,7.707031 L6.2929688,13.363281 C6.6839688,13.754281 7.317031,13.754281 7.707031,13.363281 L7.792969,13.277344 C8.183969,12.886344 8.183969,12.253281 7.792969,11.863281 L3.9296875,8 L17,8 C17.552,8 18,7.552 18,7 C18,6.448 17.552,6 17,6 L3.9296875,6 L7.792969,2.1367188 C8.183969,1.7457187 8.183969,1.1126563 7.792969,0.7226562 L7.707031,0.6367188 C7.511531,0.4412187 7.255875,0.3417969 7,0.3417969 Z" />
      </g>
    </g>
  </svg>
);

export default CustomPageViewAllArrowRight;
